export const reviews2 = ()=> {
    let reviews2Trigger;

    const sections = document.querySelectorAll('.reviews-2')

    sections?.forEach(section=> {
        const items = section.querySelectorAll('.reviews-2__swiper-slide')

        const reviewFunc = ()=> {
            if (reviews2Trigger) {
                reviews2Trigger.kill();
            }
            if (items.length > 0) {
                reviews2Trigger = ScrollTrigger.create({
                    trigger: '.reviews-2__swiper',
                    start: 'top 85%',
                    end: 'bottom 10%',
                    onEnter: () => {
                        items?.forEach((item,index)=> {
                            setTimeout(()=> {
                                item.classList.add('play');
                            },100*index)
                        })
                    },
                    onLeaveBack: () => {
                        items?.forEach((item,index)=> {
                            setTimeout(()=> {
                                item.classList.remove('play');
                            },100*index)
                        })
                    },
                });
            }
        }

        reviewFunc()

        window.addEventListener('resize',reviewFunc)

    })
}